<template>
  <div class="form-builder">
    <div class="form-field-wrapper" v-for="(field, key) in schemaX" :key="key">
      <group-field v-bind="{ ...field }" v-if="field.fieldType === 'group_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key"></group-field>

      <content-field v-if="field.fieldType === 'content_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key">
        <template slot="content"> </template>
      </content-field>

      <label-field v-if="field.fieldType === 'label_field'" :view-conditions="conditionChecker(field.condition || null)"
        :name="key" v-bind="{ ...field }"></label-field>

      <input-field :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'input_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)"></input-field>
      <autoComplete :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'autocomplete'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)" />
      <completed-field :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'complete_field'" :name="key"
        v-bind="{ ...field }" :value="value[key] ? value[key] : schemaX[key].value"
        @update="update(key, $event)"></completed-field>

      <select-field :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'select_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)"></select-field>

      <checkbox-field :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'checkbox_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)"></checkbox-field>
      <radio-field :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'radio_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)"></radio-field>
      <custom-radio-field :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'custom_radio_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)"></custom-radio-field>
      <custom-select-field :is-disabled="userRole === 'subscriber'" v-if="field.fieldType === 'custom_select_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)"></custom-select-field>
      <custom-group-radio-field :is-disabled="userRole === 'subscriber'"
        v-if="field.fieldType === 'custom_group_radio_field'" :view-conditions="conditionChecker(field.condition || null)"
        :name="key" v-bind="{ ...field }" :value="value[key] ? value[key] : schemaX[key].value"
        :hasError="$v.form[key].$error" :error="errorMessages[key]" @updateAdditional="
          updateAdditional(field.additionalKey || null, $event)
          " @update="update(key, $event)"></custom-group-radio-field>

      <custom-group-checkboxes-field :is-disabled="userRole === 'subscriber'"
        v-if="field.fieldType === 'custom_group_checkbox_field'"
        :view-conditions="conditionChecker(field.condition || null)" :name="key" v-bind="{ ...field }"
        :value="value[key] ? value[key] : schemaX[key].value" :data-additional-value="value[field.additionalKey] ? value[field.additionalKey] : ''
          " @updateAdditional="
    updateAdditional(field.additionalKey || null, $event)
    " :hasError="$v.form[key].$error" :error="errorMessages[key]"
        @update="update(key, $event)"></custom-group-checkboxes-field>
      <custom-field :is-disabled="userRole === 'subscriber'" @tipStatus="$_viewingTop($event)"
        v-if="field.fieldType === 'custom_field'" :view-conditions="conditionChecker(field.condition || null)" :name="key"
        :home-profile="homeProfile" v-bind="{ ...field }" :value="value[key] ? value[key] : schemaX[key].value"
        :data-additional-value="value[field.additionalKey] ? value[field.additionalKey] : ''
          " :hasError="$v.form[key].$error" :error="errorMessages[key]" @update="update(key, $event)"
        @updateAdditional="
          updateAdditional(field.additionalKey || null, $event)
          "></custom-field>
      <SurveyDescriptionField v-bind="{ ...field }" v-if="field.fieldType === 'section_desc_field'" />
      <FeaturesField v-bind="{ ...field }" v-if="field.fieldType === 'features_field'" />
      <CustomConditionField :is-disabled="userRole === 'subscriber'" :name="key"
        :value="value[key] ? value[key] : schemaX[key].value" :targetValue="form[field.target]" v-bind="{ ...field }"
        v-if="field.fieldType === 'condition_field'" :view-conditions="conditionChecker(field.condition || null)"
        @update="update(key, $event)" />
      <you-tube v-bind="{ ...field }" v-if="field.fieldType === 'youtube'" />
    </div>
  </div>
</template>

<script>
let performMathOperation = {
  ">": function (x, y) {
    return x > y;
  },
};

import { validationRules } from "./ValidationParser";
// import InputField from "./fields/InputField.vue";
import { mapState } from 'vuex'
import youTube from "./fields/miscellaneous/youtubeVideo.component.vue";
import InputField from "./fields/InputField.vue";
import autoComplete from "./fields/autoCompleteField.vue";
import SelectField from "./fields/SelectField.vue";
import RadioField from "./fields/RadioField.vue";
import CheckboxField from "./fields/CheckboxesField.vue";
import LabelField from "./fields/LabelField.vue";
import GroupField from "./fields/GroupField.vue";
import ContentField from "./fields/miscellaneous/ContentField.vue";
import CustomField from "./fields/miscellaneous/CustomCheckBoxesField.vue";
import CustomRadioField from "./fields/miscellaneous/CustomRadioField.vue";
import CustomSelectField from "./fields/miscellaneous/CustomSelectField.vue";
import CustomGroupRadioField from "./fields/miscellaneous/CustomGroupRadioField.vue";
import CustomGroupCheckboxesField from "./fields/miscellaneous/CustomGroupCheckboxesField.vue";
import SurveyDescriptionField from "./fields/miscellaneous/SurveyDescriptionField.vue";
import FeaturesField from "./fields/miscellaneous/FeaturesField.vue";
import CustomConditionField from "./fields/miscellaneous/CustomConditionField.vue";
import CompletedField from "./fields/CompleteField.vue";
// import M from "materialize-css";
export default {
  name: "FormBuilder",
  components: {
    InputField,
    autoComplete,
    SelectField,
    CheckboxField,
    RadioField,
    youTube,
    LabelField,
    ContentField,
    GroupField,
    CustomRadioField,
    CustomSelectField,
    CustomGroupRadioField,
    CustomGroupCheckboxesField,
    CustomField,
    SurveyDescriptionField,
    FeaturesField,
    CustomConditionField,
    CompletedField,
  },
  props: {
    homeProfile: {
      type: [Object, Boolean],
      default: false,
    },
    schema: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    isStepper: {
      type: Boolean,
      default: false,
      required: false,
    },
    stepperData: {
      type: Object,
      required: true,
    },
    currentStep: {
      type: [Number, String],
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      viewOverlay: false,
      form: {},
      // currentStep: this.stepperData.currentStep,
      vSchema: this.schema,
      nonFieldsFilterList: [
        "label_field",
        "group_field",
        "content_field",
        "section_desc_field",
        "features_field",
        "youtube",
      ],
      stepList: {},
    };
  },
  created() {
    this.getStepList();
    this.getFormFields();
  },
  mounted() {
    // setTimeout(function () {
    //   M.updateTextFields();
    //   console.log("i am being called");
    // }, 5000);
  },

  validations() {
    return { form: validationRules(this.schema) };
  },
  watch: {
    currentStep: function (nV) {
      if (nV <= Object.keys(this.stepList).length) {
        this.announceStepStatus();
        this.announceStatus();
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.User.user,
    }),
    userRole: {
      get() {
        return "user"
        return this.user && this.user.roles.length > 0
          ? this.user.roles[0]
          : false
      }
    },
    /**
     * Filter Schema based on current step
     */
    schemaX: function () {
      if (this.isStepper) {
        var results = {};
        Object.keys(this.schema).filter((key) => {
          if (this.schema[key].step === this.currentStep) {
            results[key] = this.schema[key];
          }
        });

        return results;
      }

      return this.schema;
    },

    /**
     * Gets the validation error message
     * @returns object with error message
     */
    errorMessages: function () {
      const validations = this.$v.form;

      return Object.keys(this.schema).reduce((messages, key) => {
        const rules = this.schema[key].validations;
        const rulesKeys = Object.keys(this.schema[key].validations);
        const validator = validations[key];

        if (!validator) return messages;

        for (let rule of rulesKeys) {
          if (validator[rule] !== false) continue;

          messages[key] = rules[rule].message;
          return messages;
        }

        return messages;
      }, {});
    },
  },
  methods: {
    /**
     * Creates overlay when viewing tip in ExpandTray
     * @function $_viewingTop
     * @param {boolean} $event
     * */
    $_viewingTop($event) {
      /*     console.log($event) */
      this.viewOverlay = $event;
    },
    /**
     * Checks if condition is met then show field
     *
     *
     * @param condition Object contains key to watch for and value
     *
     * @returns Bolean value
     */
    conditionChecker(condition) {
      // Check if field has condition is given
      if (condition) {
        // YES
        let fieldType = this.schema[condition.key].fieldType;
        let isArrayType = this.schema[condition.key].isMultiple;
        if (
          fieldType === "checkbox_field" ||
          (isArrayType && fieldType === "select_field")
        ) {
          return this.form[condition.key] !== null &&
            this.form[condition.key].includes(condition.value)
            ? true
            : false;
        } else {
          if (condition.operation) {
            return performMathOperation[condition.operation.operator](
              this.form[condition.key].length,
              0
            )
              ? true
              : false;
          } else {
            return this.form[condition.key] === condition.value ? true : false;
          }
        }
      }

      return true;
    },
    /**
     *  Gets total number of step by looping through schema
     */
    getStepList() {
      this.stepList = Object.values(this.schema).reduce(function (result, item) {
        result[item.step] = item.step;
        return result;
      }, {});
    },
    /**
     * Loops through schema and each field of form  (this.form)
     */
    getFormFields() {
      if (this.editMode) {
        for (let key in this.value) {
          const value = this.value[key];
          // console.log(value);
          this.$set(this.form, key, value);

          // this.update(name, value, this.schema[name].isConditional);
        }
      } else {
        for (let name in this.schema) {
          // Adds flied to this.form object || Using Vue.set to ensure that they are reactive
          if (!this.nonFieldsFilterList.includes(this.schema[name].fieldType)) {
            // Get default value from scheme
            let value = this.value[name] || this.schema[name].value;

            // console.log(this.schema[name].fieldType);

            if (
              ["custom_field", "custom_group_checkbox_field"].includes(
                this.schema[name].fieldType
              ) &&
              this.schema[name].hasOwnProperty("additionalKey")
            ) {
              this.updateAdditional(
                this.schema[name].additionalKey,
                this.value[this.schema[name].additionalKey]
              );
            }

            // this.$set(this.form, name, value);

            this.update(name, value, true);
          }
        }
      }
    },

    /**
     * Updates the specified field value in form (this.form)
     */
    update(key, value, isInitializing = false) {
      // Revalidates each field, ensuring that the rules are run on the specified field
      // and the specified state is updated within $v

      // Updates field value
      this.$set(this.form, key, value);

      // Revalidates each field, ensuring that the rules are run on the specified field
      // and the specified state is updated within $v
      this.$v.form[key].$touch();

      // Set invalid property of schema
      this.$set(this.vSchema[key], "invalid", this.$v.form[key].$invalid);

      this.$emit("input", this.form);

      this.announceStatus(isInitializing);

      this.announceStepStatus(isInitializing);
    },

    updateAdditional(key, value) {
      if (!key) return;
      // Revalidates each field, ensuring that the rules are run on the specified field
      // and the specified state is updated within $v

      // Updates field value
      this.$set(this.form, key, value);

      // // Revalidates each field, ensuring that the rules are run on the specified field
      // // and the specified state is updated within $v
      // this.$v.form[key].$touch();

      // // Set invalid property of schema
      // this.$set(this.vSchema[key], "invalid", this.$v.form[key].$invalid);

      this.$emit("input", this.form);
      this.announceStatus(false);

      this.announceStepStatus(false);

      // this.announceStatus(isInitializing);

      // this.announceStepStatus(isInitializing);
    },
    /**
     * Validates entire form
     */
    validate() {
      this.$v.$touch();
      this.announceStatus();
    },

    /**
     * Emits the overall status of form
     */
    announceStatus(initialzing = false) {
      // console.log(this.vSchema);

      // Get number of fields from schema
      const schemaLen = Object.keys(this.schema).filter(
        (key) => !this.nonFieldsFilterList.includes(this.schema[key].fieldType)
      ).length;

      // Gets number of valid field from vSchema
      const vLen = Object.keys(this.schema).filter(
        (key) =>
          this.vSchema[key].invalid === false &&
          !this.nonFieldsFilterList.includes(this.schema[key].fieldType)
      ).length;

      this.$emit("status", {
        invalid: !(vLen >= schemaLen),
        isInitializing: initialzing,
      });
    },

    /**
     * Emits the current step status
     */
    announceStepStatus(initialzing = false) {
      if (!this.isStepper) return;
      this.$emit("stepStatus", {
        stepStatus: this.stepValidator(),
        canNext: this.canNext(),
        canPrev: this.canPrev(),
        isInitializing: initialzing,
        // currentStep: this.currentStep,
      });
    },
    /**
     * Goes to next step
     */
    nextStep() {
      if (!this.isStepper) return;

      if (
        !this.stepValidator() ||
        this.currentStep >= this.stepperData.finalStep
      )
        return;
      this.currentStep++;

      this.announceStepStatus();
    },

    /**
     * Goes to previous step
     */
    prevStep() {
      if (this.currentStep <= this.stepperData.initialStep) return;
      this.currentStep--;

      this.announceStepStatus();
    },
    /**
     * Determines whether user can go to next step
     */
    canNext() {
      if (!this.isStepper) return;

      return this.stepValidator() &&
        this.currentStep < Object.keys(this.stepList).length
        ? true
        : false;
    },

    /**
     * Determines whether user can go to previous step
     */
    canPrev() {
      if (!this.isStepper) return;
      return this.currentStep <= Object.keys(this.stepList).length &&
        this.currentStep !== 1
        ? true
        : false;
    },
    stepValidator() {
      if (!this.isStepper) return;

      // Get number of fields from schema for current step
      const schemaLen = Object.keys(this.schemaX).filter(
        (key) => !this.nonFieldsFilterList.includes(this.schema[key].fieldType)
      ).length;

      // Gets length of all valid field in current step
      const vLen = Object.keys(this.schemaX).filter(
        (key) => this.vSchema[key].invalid === false
      ).length;

      // Is all the field in current step valid?
      return vLen >= schemaLen;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-field-wrapper {
  display: flow-root;
  width: 100%;
}
</style>
<style lang="scss">
.impact-level-list {
  li {
    font-size: 15px;
    margin-bottom: 8px;
  }
}

ul {
  &.criteria-list {
    padding: 18px;
    background: #e1e1e1;
    border-radius: 7px;

    li {
      margin-bottom: 8px;
    }
  }
}
</style>
